// fast click eliminates click delay in certain browsers
var fastclick = require("fastclick");
fastclick(document.body);

// svg polyfill for better xlink support
var svg4everybody = require("svg4everybody");
svg4everybody();

// outline.js
require("./util/_outline.js");

// global jquery
global.jQuery = require("jquery");

// automatically require all modules
require('./modules/_accordion.js');require('./modules/_carousel.js');require('./modules/_form.js');require('./modules/_gallery.js');require('./modules/_header.js');require('./modules/_hero.js');require('./modules/_image.js');require('./modules/_modal.js');require('./modules/_module.js');require('./modules/_nav.js');require('./modules/_table.js');
